import { render, staticRenderFns } from "./transcription_skeleton_overlay.vue?vue&type=template&id=4b0a4f07&scoped=true&"
import script from "./transcription_skeleton_overlay.vue?vue&type=script&lang=js&"
export * from "./transcription_skeleton_overlay.vue?vue&type=script&lang=js&"
import style0 from "./transcription_skeleton_overlay.vue?vue&type=style&index=0&id=4b0a4f07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0a4f07",
  null
  
)

export default component.exports